<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_calendar"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Opening hour <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-text :label="'Nom'" v-model="resource.title" required="true"></form-text>

                              </fieldset>

                            </tab>
                            <tab name="Calendrier & horaires">

                              <fieldset>
                                <div style="height: 70vh;overflow: hidden;position:relative;" id="calendar-parent">
                                <full-calendar v-if="loadCalendar"
                                               ref="fullCalendar"
                                               :timeZone="timeZone"
                                               :locales="locales"
                                               :locale="locale"
                                               height="parent"
                                               :header="headerToolbar"
                                               schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                                               :datesAboveResources="true"
                                               :weekends="true"
                                               initialView="dayGridMonth"
                                               :allDaySlot="true"
                                               :slotDuration="slotDuration"
                                               :minTime="minTime"
                                               :maxTime="maxTime"
                                               :events="events"
                                               :navLinks="true"
                                               :plugins="calendarPlugins"
                                               :views="views"
                                               :firstDay="1"
                                               :editable="true"
                                               :selectable="true"
                                               @eventClick="handleClick"
                                               @select="handleSelect"
                                               @clickDate="handleSelect"
                                               @eventDrop="handleAutoSave"
                                               @eventResize="handleAutoSave"/>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import {constants} from '../../../const.js'
    import AgendaService from './AgendaService.js';
    import Edit from '../../../layouts/Edit.vue';
    import ScopeService from '../../scope/ScopeService.js';
    import BranchService from '../branch/BranchService.js';
    import frLocale from '@fullcalendar/core/locales/fr';

    import dayGridPlugin from "@fullcalendar/daygrid";
    import timeGridPlugin from "@fullcalendar/timegrid";
    import interactionPlugin from "@fullcalendar/interaction";
    import ScheduleService from "../../reservation/ScheduleService";

    export default {
        extends: Edit,
        data () {
            return {
              loadCalendar: false,
              days_week: constants.days_week,
              slots: null,
              branches: null,
              timeZone: 'local',
              locales: [frLocale],
              locale: 'fr',
              slotDuration: null,
              minTime: null,
              maxTime: null,
              calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
              headerToolbar: {
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay"
              },
              views: {
                dayGridMonth: { titleFormat: { year: "numeric", month: "long" } }, // Vue mois
                timeGridWeek: { titleFormat: { year: "numeric", month: "short", day: "numeric" } }, // Vue semaine
                timeGridDay: { titleFormat: { year: "numeric", month: "short", day: "numeric" } }
              }
            }
        },
        created: function(){

          BranchService.query().then(response => {
            this.branches = response.data.data
            this.isLoading = false;
          });

        },
        methods:{
          refreshEvents(){
            if( this.$refs.fullCalendar )
            {
              this.$refs.fullCalendar.getApi().refetchEvents();
            }
          },
          handleClick(e){

            if(e.event.startEditable === true) {

              this.createEvent({
                id: e.event.id,
                title: e.event.title,
                start: moment(e.event.start).format('YYYY-MM-DD HH:mm:ss'),
                end: moment(e.event.end).format('YYYY-MM-DD HH:mm:ss'),
                type: [e.event._def.extendedProps.type],
                allDay: e.event.allDay,
                editable: e.event.editable,
              })

            }else{
              alert('You can\'t edit this event');
            }

          },
          handleSelect(e){ // Click on calendar for add an event

            this.createEvent({
              id: null,
              start: moment(e.start).toISOString(),//format('YYYY-MM-DD HH:mm:ss'),
              end: moment(e.end).toISOString(),//format('YYYY-MM-DD HH:mm:ss'),
              type: 'reservation',
              allDay: e.allDay
            })

          },
          handleAutoSave(e){

            let ask = confirm("Etes-vous certain de vouloir modifier cet élément ?");
            if( !ask ){
              this.refreshEvents()
              return false;
            }

            AgendaService.updateOpening({
              id: e.event.id,
              title: e.event.name,
              start_at: e.event.start,
              end_at: e.event.end,
              type: [e.event._def.extendedProps.type],
              allDay: e.event.allDay,
              autoSave: true
            }).then(response => {
              this.refreshEvents()
            }).catch(error => {
              console.log(error)
              this.refreshEvents()
            });
          },
          createEvent(event) {

            alert("createEvent: " + this.$route.name)


          },
          events: function(info, successCallback, failureCallback) {

            var self = this

            console.log("OUPS")

            AgendaService.getOpenings(
                this.resource.id,
                info.start.valueOf(),
                info.end.valueOf()
            ).then(response => {

              let events = []
              for(let e of response.data){
                events.push({
                  id: e.id,
                  title: e.title,
                  start: e.start_at,
                  end: e.end_at,
                  //type: e.type,
                  //className: 'event-type-' + e.type,
                  allDay: e.all_day,
                  editable: e.editable
                })
              }
              successCallback(events);
            });

          },
          resourceLoaded: function(){
            let self = this;


            ScopeService.get(this.$store.state.scope.id).then((response) => {

              self.slotDuration = response.data.schedule_interval ? response.data.schedule_interval : '00:15'
              self.minTime = response.data.schedule_min_time ? response.data.schedule_min_time : '00:00:00'
              self.maxTime = response.data.schedule_max_time ? response.data.schedule_max_time : '23:00:00'

              self.loadCalendar = true;
            })

            this.localesLoaded = true;
            this.initialize();
          },
          getResource: function(){
              return AgendaService
          }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/agenda/Edit.vue